<template>
  <div class='quote-side-container' @click='_tapTab'>
    <div :class='["quote-side-controller", sideWarpClass]'>
      <div v-for='(item, index) in tabList' :key='index' :data='index' :class='["quote-side-tab", {"quote-side-tab-active": trendStatus === item.key}]'>{{item.text}}</div>
    </div>
    <div class='quote-side-detail'>
      <div v-if='trendStatus === TREND_WD' class='quote-side-grp'>
        <div class='quote-side-colcontainer'>
          <div class='quote-side-column'>
            <span v-for='(item, index) in offerGrp' :key='item.key' class='quote-side-span'>{{'卖' + (5 - index)}}</span>
            <span v-for='(item, index) in bidGrp' :key='item.key' class='quote-side-span'>{{'买' + (index + 1)}}</span>
          </div>
          <div class='quote-side-column'>
            <span v-for='(item, index) in offerGrp' :style='{color: colorMap[item.color]}' class='quote-side-span'>{{item.price}}</span>
            <span v-for='(item, index) in bidGrp' :style='{color: colorMap[item.color]}' class='quote-side-span'>{{item.price}}</span>
          </div>
          <div class='quote-side-column'>
            <span v-for='(item, index) in offerGrp' class='quote-side-span'>{{item.amount}}</span>
            <span v-for='(item, index) in bidGrp' class='quote-side-span'>{{item.amount}}</span>
          </div>
        </div>
      </div>
      <div v-if='trendStatus === TREND_MX' class='quote-side-tick'>
        <div v-if='noData' class='quote-side-tick-none'>No Data</div>
        <div v-else class='quote-side-colcontainer'>
          <div class='quote-side-column'>
            <span v-for='(item, index) in tick' :key='item.key' class='quote-side-span'>{{item.time}}</span>
          </div>
          <div class='quote-side-column'>
            <span v-for='(item, index) in tick' :key='item.key' :style='{color: colorMap[item.color]}' class='quote-side-span'>{{item.price}}</span>
          </div>
          <div class='quote-side-column'>
            <span v-for='(item, index) in tick' :key='item.key' :style='{color: colorMap[item.direction]}' class='quote-side-span'>{{item.amount}}</span>
          </div>
        </div>
      </div>
      <div v-if='trendStatus === TREND_CJ' class='quote-side-fundflow'>
        <canvas ref='canvasContainer' class='quote-side-canvas'></canvas>
        <div :class='["quote-side-colcontainer", "quote-side-fundflow-detail"]'>
          <div class='quote-side-column'>
            <span v-for='(item, index) in fundflow' :key='item.key' :style='{color: item.color}' class='quote-side-span'>{{item.legend}}</span>
          </div>
          <div class='quote-side-column'>
            <span v-for='(item, index) in fundflow' :key='item.key' :style='{color: item.color}' class='quote-side-span'>{{item.amount}}</span>
          </div>
          <div class='quote-side-column'>
            <span v-for='(item, index) in fundflow' :key='item.key' :style='{color: item.color}' class='quote-side-span'>{{item.rate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util, {
  bind,
  unBind,
  numberFormat,
} from '../../util/index.js';
import {TREND_TYPE} from '../../viewmodel/index.js';
import {Conf} from '../../viewmodel/config.js';
import VolumnPieComponent from '../../viewmodel/additionalcontext/volumnpie.js';
const {TREND_WD, TREND_MX, TREND_CJ} = TREND_TYPE;
const {colorMap} = Conf.BaseContext;
export default {
  name: 'SideDetail',
  data() {
    return {
      volumnCanvas: null,
      sideWarpClass: '',
      colorMap,
      TREND_WD,
      TREND_MX,
      TREND_CJ,
    }
  },
  props: {
    baseSize: {
      type: Number,
      required: true,
    },
    tabList: {
      type: Array,
      default: () => ([]),
    },
    isLoaded: {
      type: Boolean,
    },
    trendStatus: {},
    changeSide: {
      type: Function,
      default: () => {}
    },
    bidGrp: {
      type: Array,
      default: () => ([]),
    },
    offerGrp: {
      type: Array,
      default: () => ([]),
    },
    tick: {
      type: [Array, Object]
    },
    fundflowIn: {
      type: Array,
      default: () => ([]),
    },
    fundflowOut: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    fundflow() {
      return [...this.fundflowIn, ...this.fundflowOut];
    },
    noData() {
      return this.isLoaded && Util.isArray(this.tick) && this.tick.length === 0;
    }
  },
  watch: {
    fundflow() {
      this.$nextTick(() => {
        this.drawCJ();
      })
    },
    trendStatus(newVal, oldVal) {
      // 离开时清理canvas
      if (newVal !== TREND_CJ && oldVal === TREND_CJ && this.volumnCanvas) {
        this.volumnCanvas.destroy();
        this.volumnCanvas = null;
      }
    },
    tabList(newVal) {
      const len = newVal.length;
      if (len === 2) {
        this.sideWarpClass = 'quote-side-controller-nofund'
      } else {
        this.sideWarpClass = '';
      }
    }
  },
  methods: {
    _tapTab(e) {
      const index = e.target.getAttribute('data');
      const key = this.tabList[index] && this.tabList[index].key || undefined;
      this.changeSide(key);
    },
    drawCJ() {
      if (this.volumnCanvas) {
        this.volumnCanvas.destroy();
        this.volumnCanvas = null;
      }
      const {VolumnPie, BaseContext} = Conf;
      const {colorMap} = BaseContext;
      const {sizeRatio, fontFamily} = VolumnPie;
      this.volumnCanvas = new VolumnPieComponent({
        ele: this.$refs.canvasContainer,
        data: this.fundflow,
        legend: {
          fontSize: sizeRatio * this.baseSize,
          fontFamily,
          leftLegend: {
            text: '主动卖',
            color: colorMap[0],
          },
          rightLegend: {
            text: '主动买',
            color: colorMap[1],
          }
        }
      });
    },
  }
}
</script>